import { NavBar } from "../LandingPage/NavBar";
import { NavBarMobile } from "../LandingPage/NavBarMobile";
import { useContext } from "react";
import { LanguageContext } from "../LanguageProvider";
import { CertificatesGrid } from "./CertificatesGrid";
// import { useTranslation } from "react-i18next";

export const CertificatesPage = () => {
  const { polish } = useContext(LanguageContext);

  // const { t, i18n } = useTranslation();

  return (
    <div className="flex flex-col items-center bg-black w-full h-fit ">
      <div className="p-4 lg:p-36 w-full lg:pr-56 flex flex-col items-center gap-4 lg:gap-12">
        {!polish && (
          <h1 className="text-[1.5rem] md:text-[2.5rem] text-yellow-orange">
            My certificates:
          </h1>
        )}
        {polish && (
          <h1 className="text-[1.5rem] md:text-[2.5rem] text-yellow-orange">
            Moje certyfikaty:
          </h1>
        )}
        <CertificatesGrid />
      </div>
      <div className="hidden md:flex fixed right-0">
        <NavBar />
      </div>
      <div className="fixed bottom-0">
        <NavBarMobile />
      </div>
    </div>
  );
};
